export enum SUBSCRIPTION_VARIANT {
  MONTHLY_BASE = 'monthly_base',
  MONTHLY_PREMIUM = 'monthly_premium',
  LIFETIME = 'lifetime',
}
